import IconButton from 'components/common/IconButton';
import { Card, Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useState } from 'react';
import ActionsModal from './ActionsModal';
import { TitleGenerator } from 'utils/TitleGenerator';
import ShareModal from './ShareModal';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/checkPermission';

const SelectBar = ({
  selected,
  setSelected,
  handleCheckbox,
  setCheckChanges
}) => {
  // * States
  const [showActiveModal, setShowActiveModal] = useState(false);
  const [showPauseModal, setShowPauseModal] = useState(false);
  const [showFinishModal, setShowFinishModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // modal de compartir honorarios
  const [showShareModal, setShowShareModal] = useState(false);
  const userLogged = useSelector(state => state.login.currentUser);
  // * Props
  // * Methods
  const GenerateLink = (id, title) =>
    `${process.env.REACT_APP_CLIENT_DETAIL}${id}/${TitleGenerator(title)}`;

  const HandleShare = () => {
    const subject = '🏡 Propiedades de su interés';

    const body =
      'Aquí te envío la lista de propiedades: \n\n' +
      selected
        .map(item => `${item.title} \n ${GenerateLink(item.id, item.title)}`)
        .join('\n\n');

    window.location.href = `mailto:?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
  };

  const hasPermissionSelected = action => {
    if (selected.length === 0) return false;
    console.log('dadsadads');
    const countPermission = selected.filter(prop =>
      checkPermission(action, userLogged, prop.branch_office)
    );
    console.log(countPermission);
    return countPermission.length === selected.length ? true : false;
  };

  // * Render

  return (
    <>
      {/* Select bar */}
      <Card className="mb-1 bg-white">
        <Card.Body>
          <Row>
            <Col xs={12} className="d-flex justify-content-between">
              <div className="d-flex align-items-center" style={{ gap: 10 }}>
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip>
                      {selected.length
                        ? 'Deseleccionar todas'
                        : 'Seleccionar todas'}
                    </Tooltip>
                  }
                >
                  <Form.Check
                    type="checkbox"
                    onChange={handleCheckbox}
                    checked={!!selected.length}
                  />
                </OverlayTrigger>

                {/* Publish */}
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Activar</Tooltip>}
                >
                  <span>
                    <IconButton
                      buttonSize="sm"
                      style={{ width: 30 }}
                      icon="play"
                      onClick={() => setShowActiveModal(true)}
                      variant="light"
                      className="px-2"
                      disabled={
                        selected.length === 0 &&
                        !hasPermissionSelected('Edit Properties')
                      }
                    />
                  </span>
                </OverlayTrigger>

                {/* Pause */}
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Pausar</Tooltip>}
                >
                  <span>
                    <IconButton
                      buttonSize="sm"
                      style={{ width: 30 }}
                      icon="fa-pause"
                      onClick={() => setShowPauseModal(true)}
                      variant="light"
                      className="px-2"
                      disabled={
                        selected.length === 0 &&
                        !hasPermissionSelected('Edit Properties')
                      }
                    />
                  </span>
                </OverlayTrigger>

                {/* Finish */}
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Finalizar</Tooltip>}
                >
                  <span>
                    <IconButton
                      buttonSize="sm"
                      style={{ width: 30 }}
                      icon="flag-checkered"
                      onClick={() => setShowFinishModal(true)}
                      variant="light"
                      className="px-2"
                      disabled={
                        selected.length === 0 &&
                        !hasPermissionSelected('Edit Properties')
                      }
                    />
                  </span>
                </OverlayTrigger>

                {/* Delete */}
                <OverlayTrigger
                  placement={'bottom'}
                  overlay={<Tooltip>Eliminar</Tooltip>}
                >
                  <span>
                    <IconButton
                      buttonSize="sm"
                      style={{ width: 30 }}
                      icon="trash-can"
                      onClick={() => setShowDeleteModal(true)}
                      variant="light"
                      className="px-2"
                      disabled={
                        selected.length === 0 &&
                        !hasPermissionSelected('Delete properties')
                      }
                    />
                  </span>
                </OverlayTrigger>

                {/* Email Share */}
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Compartir por correo</Tooltip>}
                >
                  <span>
                    <IconButton
                      buttonSize="sm"
                      style={{ width: 30 }}
                      icon="envelope"
                      onClick={HandleShare}
                      variant="light"
                      className="px-2"
                      disabled={
                        selected.length === 0 &&
                        !hasPermissionSelected('Edit Properties')
                      }
                    />
                  </span>
                </OverlayTrigger>

                {/* Share */}
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Compartir honorarios</Tooltip>}
                >
                  <span>
                    <IconButton
                      buttonSize="sm"
                      style={{ width: 30 }}
                      icon="share"
                      onClick={() => setShowShareModal(true)}
                      variant="light"
                      className="px-2"
                      disabled={
                        selected.length === 0 && !hasPermissionSelected()
                      }
                    />
                  </span>
                </OverlayTrigger>
              </div>
              <div>
                <span>
                  {selected.length}{' '}
                  {selected.length === 1 ? 'seleccionada' : 'seleccionadas'}
                </span>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Modals */}

      {/* Pause Modal */}
      {showPauseModal && (
        <ActionsModal
          selected={selected}
          setSelected={setSelected}
          setShow={setShowPauseModal}
          setCheckChanges={setCheckChanges}
          status="paused"
          actionName="pausadas"
          modalMsg="se pausarán y los clientes ya no podrán verlas ni consultar por ellas."
          actionTitle="Pausar"
        />
      )}

      {/* Active Modal */}
      {showActiveModal && (
        <ActionsModal
          selected={selected}
          setSelected={setSelected}
          setShow={setShowActiveModal}
          setCheckChanges={setCheckChanges}
          status="published"
          actionName="activadas"
          modalMsg="se activarán y los clientes podrán verlas y consultar por ellas."
          actionTitle="Activar"
        />
      )}

      {/* Finish Modal */}
      {showFinishModal && (
        <ActionsModal
          selected={selected}
          setSelected={setSelected}
          setShow={setShowFinishModal}
          setCheckChanges={setCheckChanges}
          status="finished"
          actionName="finalizadas"
          modalMsg="se finalizarán y se marcarán como una operación realizada."
          actionTitle="Finalizar"
        />
      )}

      {/* Delete Modal */}
      {showDeleteModal && (
        <ActionsModal
          selected={selected}
          setSelected={setSelected}
          setShow={setShowDeleteModal}
          setCheckChanges={setCheckChanges}
          status="deleted"
          actionName="eliminadas"
          modalMsg="se eliminarán. Se marcarán como operación no concretada y los clientes no podrán verlas."
          actionTitle="Eliminar"
        />
      )}

      {/* Share Modal */}
      {showShareModal && (
        <ShareModal
          selected={selected}
          setSelected={setSelected}
          setShow={setShowShareModal}
          setCheckChanges={setCheckChanges}
        />
      )}
    </>
  );
};

SelectBar.propTypes = {
  selected: PropTypes.array.isRequired,
  setSelected: PropTypes.func.isRequired,
  handleCheckbox: PropTypes.func.isRequired,
  setCheckChanges: PropTypes.func.isRequired
};

export default SelectBar;
